import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = [".open"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { slot: "footer" }
const _hoisted_4 = ["disabled"]

import { ref } from 'vue';
import { useStore } from 'vuex';
import EpinioCatalogServiceModel from 'models/catalogservices';
import { EPINIO_TYPES } from '../../types';
import { epinioExceptionToErrorsArray } from '../../utils/errors';
import Banner from '@components/Banner/Banner.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CatalogServiceDeleteModal',
  emits: ['deleted'],
  setup(__props, { expose: __expose, emit: __emit }) {

const showDeleteModal = ref<boolean>(false);
const catalogServiceToDelete = ref<EpinioCatalogServiceModel | null>(null);
const errors = ref<Array<string>>([]);
const deletingCatalogService = ref<boolean>(false);
const hasAssociatedServices = ref<boolean>(false);

const store = useStore();
const t = store.getters['i18n/t'];

function openDelete(row: EpinioCatalogServiceModel) {
  catalogServiceToDelete.value = row;
  showDeleteModal.value = true;
  hasAssociatedServices.value = !!row.bound_services;
}

function closeDelete() {
showDeleteModal.value = false;
errors.value = [];
hasAssociatedServices.value = false;
catalogServiceToDelete.value = null;
}

async function onSubmitDelete() {
if (!catalogServiceToDelete.value) {
    return;
}
const catalogServiceName = catalogServiceToDelete.value.meta.name;
try {
    deletingCatalogService.value = true;
    await catalogServiceToDelete.value.remove();
    store.dispatch('growl/success', {
      title:   t('epinio.growl.catalogServices.delete.success.title'),
      message: t('epinio.growl.catalogServices.delete.success.message', { name: catalogServiceName }),
    });
    closeDelete();
    emit('deleted');
    store.dispatch('epinio/findAll', { type: EPINIO_TYPES.CATALOG_SERVICE, opt: { force: true } });
} catch(e) {
    errors.value = [];
    errors.value = epinioExceptionToErrorsArray(e).map(JSON.stringify);
    store.dispatch('growl/error', {
      title:   t('epinio.growl.catalogServices.delete.error.title'),
      message: t('epinio.growl.catalogServices.delete.error.message', { name: catalogServiceName }),
    });
} finally {
    deletingCatalogService.value = false;
}
}
__expose({
  openDelete
});
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-modal", {
    ".open": showDeleteModal.value,
    title: "Are you sure?",
    onModalClose: closeDelete
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createTextVNode("You are attempting to delete the Catalog Service ", -1)),
        _createElementVNode("strong", null, _toDisplayString(catalogServiceToDelete.value?.meta.name), 1),
        _cache[1] || (_cache[1] = _createTextVNode(".", -1))
      ]),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "Are you sure you want to proceed?", -1)),
      _cache[4] || (_cache[4] = _createTextVNode()),
      (hasAssociatedServices.value)
        ? (_openBlock(), _createBlock(Banner, {
            key: 0,
            color: "warning",
            label: "This catalog service is currently associated with one or more services. Deleting it may affect those services."
          }))
        : _createCommentVNode("", true),
      _cache[5] || (_cache[5] = _createTextVNode()),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (err, i) => {
        return (_openBlock(), _createBlock(Banner, {
          key: i,
          color: "error",
          label: err
        }, null, 8, ["label"]))
      }), 128))
    ]),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("trailhand-button", {
        variant: "secondary",
        class: "mr-10",
        onButtonClick: closeDelete
      }, "Cancel", 32),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createElementVNode("trailhand-button", {
        disabled: deletingCatalogService.value,
        variant: "destructive",
        onButtonClick: onSubmitDelete
      }, _toDisplayString(deletingCatalogService.value ? 'Deleting...' : _unref(t)('generic.delete')), 41, _hoisted_4)
    ])
  ], 40, _hoisted_1))
}
}

})